import { FC } from "react"
import { Lead } from "../../../../../../../types"
import SectionCell from "../../../../../section/cell"
import { If } from "../../../../.."

interface Props {
  data: Lead
  cols: number
}

const PropertyLocation: FC<Props> = ({ data, cols }) => {
  const {
    details: {
      location: { state, city, street, county, zipcode }
    }
  } = data
  return (
    <div className={`grid grid-cols-${cols} gap-4`}>
      <If
        condition={!!street}
        then={
          <SectionCell
            label="Street address"
            value={street}
            className="!pt-0"
          />
        }
      />
      <SectionCell label="City" value={city} className="!pt-0" />
      <SectionCell label="State" value={state} className="!pt-0" />
      <SectionCell label="County" value={county} className="!pt-0" />
      <SectionCell label="Zipcode" value={zipcode} className="!pt-0" />
    </div>
  )
}

export default PropertyLocation
